import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const numberFormats = {
  'en-US': { 
    currency: {
      style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2
    }
  },
  'es-CO': {
    currency: {
      style: 'currency', currency: 'COP', currencyDisplay: 'symbol', minimumFractionDigits: 0, maximumFractionDigits: 0
    }
  },
  'es-PE': {
    currency: {
      style: 'currency', currency: 'PEN', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2
    }
  },
  'pt-BR': {
    currency: {
      style: 'currency', currency: 'BRL', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2
    }
  },
  'es-CL': {
    currency: {
      style: 'currency', currency: 'CLP', currencyDisplay: 'symbol', minimumFractionDigits: 0, maximumFractionDigits: 0
    }
  },
  'es-MX': {
    currency: {
      style: 'currency', currency: 'MXN', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2
    }
  },
}

export default new VueI18n({
  locale: "es" || "en" || "pt",
  fallbackLocale: "es" || "en",
  messages: loadLocaleMessages(),
  numberFormats: numberFormats
});
